




























































import { Component, Vue, Prop } from 'vue-property-decorator'
import FormatDate from '@/helpers/FormatDate'
import { UserModel } from '@/models'
import PreviewText from '@/helpers/PreviewText'
import { hanldeUserStatus } from '@/helpers/Common'
import {getModule} from "vuex-module-decorators";
import store from "@/store";
import UserInfo from "@/store/modules/UserInfo";
const UserModule = getModule(UserInfo, store)

@Component
export default class LikeNotification extends Vue {
  @Prop() notifications!: any[]
  private currentUser: UserModel = new UserModel()
  avatarDefault = require('@/assets/images/avatar-default.png')
  eLikeType: any = ELikeType

  get userLogin() {
    return this.$store.state.userInfo.user
  }

  private setUserLogin(user: any) {
    this.$set(this.currentUser, 'userId', user.info.id)
    this.$set(this.currentUser, 'userName', user.info.name)
    this.$set(this.currentUser, 'avatar', user.profile.avatar)
  }

  /**
   * format date
   */
  formatDate(date: string) {
    return FormatDate.formatCompact(date)
  }

  isCommonTopicLike(like_type: ELikeType) {
    return [
      ELikeType.COMMON_TOPIC,
      ELikeType.COMMON_TOPIC_COMMENT
    ].includes(like_type)
  }

  getLikeIconRenderList(notification: any) {
    const icons = notification.like_icon || []
    if (icons.length || !this.isCommonTopicLike(notification.like_type)) {
      return icons
    }
    return ['']
  }

  getLikeNotificationAvatar(
    like_type: ELikeType,
    imgArray: string[],
    index: number
  ) {
    const img_path = imgArray[index]
    let likeNotificationGroup = [
      ELikeType.GROUP_TOPIC,
      ELikeType.GROUP_TOPIC_COMMENT
    ]
    let likeNotificationCommonTopic = [
      ELikeType.COMMON_TOPIC,
      ELikeType.COMMON_TOPIC_COMMENT
    ]
    let likeNotificationChat = [ELikeType.CHAT]

    if (
      likeNotificationGroup.includes(like_type) ||
      likeNotificationChat.includes(like_type)
    ) {
      return img_path || this.$store.state.userInfo.user.company_logo_default
    } else if (likeNotificationCommonTopic.includes(like_type)) {
      return img_path || this.$store.state.commonTopic.info.avatar || this.avatarDefault
    }
  }

  hideDropdownLike(event: any) {
    if(!event.ctrlKey) {
      this.$emit('hideDropdownLike')
    }
  }

  goToDetail(name: string, params: any, query: any) {
    return { name: name, params: params, query: query }
  }

  goToNotificationDetail(index: number) {
    let notification = this.notifications[index]
    let like_type = notification.like_type
    let target_id = notification.like_target_id
    let group_id = notification.group_id
    let commet_id = notification.comment_id

    switch (like_type) {
      case ELikeType.GROUP_TOPIC:
      case ELikeType.GROUP_TOPIC_COMMENT:
        return this.goToDetail(
          'group-new-feed-topic-detail',
          {
            groupId: `${group_id}`,
            topicId: `${target_id}`,
            from: this.$route.path
          },
          commet_id ? { commentSearchId: commet_id } : {}
        )
      case ELikeType.COMMON_TOPIC:
      case ELikeType.COMMON_TOPIC_COMMENT:
        return this.goToDetail(
          'common-topic-new-feed-topic-detail',
          {
            topicId: `${target_id}`,
            from: this.$route.path
          },
          commet_id ? { commentSearchId: commet_id } : {}
        )
      case ELikeType.CHAT:
        return this.goToDetail(
          'chat-detail',
          {
            groupChatId: `${target_id}`,
            from: this.$route.path
          },
          commet_id ? { message: commet_id } : {}
        )
      default:
        return {}
    }
  }

  /**
   * Get display name of users who liked
   * Handles anonymous likes, hidden administrators, and regular user listing
   */
  handleGetUserNameLike(notification: any) {
    const users: any[] = notification.update_by_user || []

    // Case 1: Anonymous likes is allowed
    if (notification.allow_like_anonymous === true) {
      if (users.length > 1) {
        return this.$tc('like_notification.like_count', notification.like_count || users.length)
      } else {
        return this.$t('common.suffix.anonymous')
      }
    }

    // Case 2: Non-anonymous, but all following users in list are hidden administrators (length > 1)
    // Display as a generic "X admins" count
    if (users.length > 1 && users.every((user: any) => user.hide_administrator)) {
      return this.$tc('like_notification.group_admin_count', users.length)
    }

    const san = this.$t('common.suffix.san') as string
    const comma = this.$t('common.suffix.comma') as string

    const allLabels: string[] = []

    // Case 3: List individual names for users
    users.forEach((item: any) => {
      if (item.hide_administrator) {
        // Replace name with generic admin tag if the admin identity is hidden
        allLabels.push(this.$t('common.suffix.admin') as string)
      } else {
        const displayName = hanldeUserStatus(item.name, item.user_active_status)

        // Check if user has left or is inactive for special styling
        if (item.user_active_status) {
          allLabels.push(
            `<span class='text-secondary-tint-less'>${displayName}</span>${san}`
          )
          return
        }

        allLabels.push(displayName + san)
      }
    })

    return allLabels.join(comma)
  }

  goToLike() {
    if (this.$route.name === 'like') {
      this.$emit('hideDropdownLike')
    } else {
      this.$router.push({ name: 'like' })
    }
  }

  /**
   * Constructs the full localized description for a like notification.
   * Calculates the parts of the sentence (user, count, target, character) based on notification data.
   */
  handleLikeDescription(notification: any) {    
    // Check if the like configuration is set to anonymous
    const isAnonymous = notification.allow_like_anonymous === true
    
    // 1. Calculate the "and X others" suffix (omitted for anonymous likes)
    let likeCountText = ''
    if (notification.like_count > 2 && !isAnonymous) {
      const otherStr = String(this.$t('common.suffix.other'))
      const remainingCount = notification.like_count - 2
      const nameStr = String(this.$t('common.suffix.name'))
      likeCountText = `${otherStr}${remainingCount}${nameStr}`
    }

    // 2. Determine the target text of the like (the topic name, or a default fallback for comments)
    let targetText = ''
    if (notification.like_target) {
      targetText = PreviewText.covertToPreviewText(notification.like_target, 50).text
    } else if (
      notification.like_type === ELikeType.GROUP_TOPIC_COMMENT ||
      notification.like_type === ELikeType.COMMON_TOPIC_COMMENT
    ) {
      targetText = this.$t('like_notification.comment') as string
    }

    // 3. Determine the 'like' character to display (could be a customized like icon text)
    const likeCharText = notification.like_character_change
      ? notification.like_character_change
      : this.$t('like_notification.like_text')

    // 4. Construct and return the final translated string utilizing the generated parts
    return this.$t(`like_notification.like_type_${notification.like_type}`, {
      user_name: this.handleGetUserNameLike(notification),
      like_count: likeCountText,
      like_target: targetText,
      like_char: likeCharText,
      comment_content: notification.comment_content
    })
  }
}

export enum ELikeType {
  GROUP_TOPIC = 1,
  GROUP_TOPIC_COMMENT = 2,
  COMMON_TOPIC = 3,
  COMMON_TOPIC_COMMENT = 4,
  CHAT = 5
}
